import React, { useState } from 'react';
import { Play, Clock, User } from 'lucide-react';
import { sermons } from '../mockData';

const Sermons = () => {
  const [selectedSermon, setSelectedSermon] = useState(null);

  return (
    <div className="page-container sermons-page">
      {/* Hero Section */}
      <section className="page-hero">
        <div 
          className="page-hero-bg" 
          style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1515616227676-603a1c547b3b?w=1920)' }}
        >
          <div className="page-hero-overlay" />
        </div>
        <div className="page-hero-content">
          <h1 className="page-hero-title">Sermons & Messages</h1>
          <p className="page-hero-subtitle">
            Be inspired and encouraged by powerful teachings from God's Word
          </p>
        </div>
      </section>

      {/* Sermons Section */}
      <section className="content-section">
        <div className="container">
          {selectedSermon ? (
            /* Sermon Player */
            <div className="sermon-player">
              <button 
                className="back-btn"
                onClick={() => setSelectedSermon(null)}
              >
                ← Back to Sermons
              </button>
              <div className="player-wrapper">
                <div className="video-placeholder">
                  <Play size={64} />
                  <p>Video player will load here</p>
                  <p className="video-note">YouTube video: {selectedSermon.title}</p>
                </div>
              </div>
              <div className="sermon-details">
                <h2>{selectedSermon.title}</h2>
                <div className="sermon-meta-row">
                  <div className="sermon-meta-item">
                    <User size={18} />
                    <span>{selectedSermon.speaker}</span>
                  </div>
                  <div className="sermon-meta-item">
                    <Clock size={18} />
                    <span>{selectedSermon.duration}</span>
                  </div>
                  <div className="sermon-meta-item">
                    <span>{selectedSermon.date}</span>
                  </div>
                </div>
                <p className="sermon-description">{selectedSermon.description}</p>
              </div>
            </div>
          ) : (
            /* Sermons Grid */
            <div className="sermons-grid">
              {sermons.map(sermon => (
                <div 
                  key={sermon.id} 
                  className="sermon-card"
                  onClick={() => setSelectedSermon(sermon)}
                >
                  <div className="sermon-thumbnail">
                    <img src={sermon.thumbnail} alt={sermon.title} />
                    <div className="play-overlay">
                      <Play size={48} />
                    </div>
                    <div className="duration-badge">{sermon.duration}</div>
                  </div>
                  <div className="sermon-card-content">
                    <h3 className="sermon-title">{sermon.title}</h3>
                    <p className="sermon-speaker">
                      <User size={16} />
                      {sermon.speaker}
                    </p>
                    <p className="sermon-date">{sermon.date}</p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* Subscribe Section */}
      {!selectedSermon && (
        <section className="subscribe-section">
          <div className="container">
            <div className="subscribe-content">
              <h2>Never Miss a Message</h2>
              <p>Subscribe to our YouTube channel for weekly sermons and teachings</p>
              <a 
                href="https://www.youtube.com/@UnitedChristianFellowship0" 
                target="_blank" 
                rel="noopener noreferrer"
                className="btn btn-primary"
              >
                Subscribe on YouTube
              </a>
            </div>
          </div>
        </section>
      )}
    </div>
  );
};

export default Sermons;
